// import URL_BASE, { URL_TASK } from "../../utils/url"; //
const URLS = {
  post: {
    task: {
      addComment: "/v1/task/addComment",
      addNote: "/v1/task/addNote",
      create: "/v1/task/create",
      updateNote: "/v1/task/updateNote",
      updateComment: "/v1/task/updateComment",
      updateTask: "/v1/task/updateTask",
      changeTaskStatus: {
        taskId: (taskId: number | string) =>
          `/v1/task/changeTaskStatus/${taskId}`,
      },
      initializeTasks: {
        propertyId: (propertyId: number | string, userId: number | string) =>
          `/v1/task/initializeTasks/${propertyId}/${userId}`,
      },
      search: "v1/task/searchTasks",
    },
    property: {
      create: "/v1/property/create",
      updatePhase: "/v1/property/updatePhase",
      updateComment: "/v1/property/updateComment",
      updatePaymentInformation: "/v1/property/updatePaymentInformation",
      updatePropertyDetails: "/v1/property/updatePropertyDetails",
      updatePropertyLandlord: "/v1/property/updatePropertyLandlord",
      updatePropertyFeatures: "/v1/property/updatePropertyFeatures",
      updatePropertyGroup: "/v1/property/updatePropertyGroup",
      updatePropertyManagment: "/v1/property/updatePropertyManagement",
      createVideoLink: "/v1/property/createVideoLink",
      updateVideoLink: "/v1/property/updateVideoLink",
      updateDocumentType: "/v1/property/updateDocumentType",
      updateImageOrder: "/v1/property/updateImageOrder",
      search: "/v1/property/searchProperties",
      searchPublic: `/v1/public/property/listProperties`,
      getPropertiesByIds: `/v1/public/property/getPropertiesByIds`,
      listCollections: `v1/public/property/listCollections`,
    },
    landlord: {
      update: "/v1/landlord/update",
      create: "/v1/landlord/create",
    },
    tenant: {
      createInterest: "v1/tenant/subscribe",
      updateCandidate: "v1/tenant/updateCandidate",
      updateCandidateScreening: "v1/tenant/updateCandidateScreening",
      updateTenant: "v1/tenant/update",
    },
    events: {
      subscribeToEvent: "/v1/event/participate",
      getEventsByIds: `/v1/public/event/getEventsByIds`,
    },
    datakeeper: {
      sessions: "/v1/public/tenant/datakeeper/sessions",
      processed: "/v1/public/tenant/datakeeper/processed",
      unabletocomplete: "/v1/public/tenant/datakeeper/unabletocomplete",
    },
    file: {
      prepare: {
        params: (
          userId: number | string,
          candidateScreeningId: number | string,
          fileAccess: string,
        ) =>
          `/v1/files/prepareCandidateFiles/${userId}/TENANT_MICROSERVICE/${candidateScreeningId}/${fileAccess}`,
      },
      propertyImageUrls: "/v1/files/propertyImageUrls",
      downloadUrls: "/v1/files/downloadUrls",
      updatePropertyAssetsWp: "/v1/property/updatePropertyAssetsWp",
    },
    payment: {
      createPaymentIntent: "/v1/public/user/createPayment",
    },
  },
  get: {
    task: {
      condensed: {
        taskId: (taskId: number | string) => `/v1/task/condensed/${taskId}`,
        byProperty: {
          propertyId: (propertyId: number | string) =>
            `/v1/task/condensed/byProperty/${propertyId}`,
        },
      },
      property: {
        id: (id: number | string) => `/v1/task/property/${id}`,
      },
      phase: {
        all: "/v1/task/phase/all",
      },
      priority: {
        all: "/v1/task/priority/all",
      },
      status: {
        all: "/v1/task/status/all",
      },
      type: {
        all: "/v1/task/type/all",
      },
      taskId: (taskId: number | string) => `/v1/task/getTaskById/${taskId}`,
    },
    user: {
      all: "/v1/user/all",
      roles: "/v1/user/roles",
      teams: "/v1/user/teams",
      cognitoUsername: {
        username: (username: string) =>
          `/v1/public/user/cognitoUsername/${username}`,
      },
      payment: {
        paymentCheck: {
          userId: (id: number | string) => `/v1/public/user/checkPayment/${id}`,
        },
      },
    },
    property: {
      getPropertyById: {
        id: (id: number | string) => `/v1/property/getPropertyById/${id}`,
      },
      getPublicPropertyBySlug: {
        slug: (slug: string) => `/v1/public/property/getPropertyBySlug/${slug}`,
      },
      getPublicPropertyById: {
        id: (id: number | string) =>
          `/v1/public/property/getPropertyById/${id}`,
      },
      all: {
        teamId: (teamId: number | string) => `/v1/property/all/${teamId}`,
      },
      condensed: {
        propertyId: (propertyId: number | string) =>
          `/v1/property/condensed/${propertyId}`,
      },
      phase: {
        all: "/v1/property/phase/all",
      },
      paymentStatus: {
        all: "/v1/property/paymentStatus/all",
      },
      propertyManagementOptions: {
        all: "/v1/property/getPropertyManagementOptions",
      },
    },
    landlord: {
      all: "/v1/landlord/all",
      condensed: {
        landlordId: (landlordId: number | string) =>
          `/v1/landlord/condensed/${landlordId}`,
      },
      id: (id: number | string) => `/v1/landlord/getLandlordById/${id}`,
    },
    file: {
      id: (id: number | string) => `/v1/files/${id}`,
    },
    tenant: {
      candidateById: {
        candidateId: (candidateId: number | string) =>
          `/v1/tenant/candidateById/${candidateId}`,
      },
      stages: `v1/tenant/stages`,
      subscribeToVideoViewing: {
        params: (userId: number, propertyId: number) =>
          `v1/tenant/subscribeToVideoViewing/${userId}/${propertyId}`,
      },
      profile: {
        profilesByTenantId: (tenantId: number | string) =>
          `/v1/tenant/profile/profilesByTenantId/${tenantId}`,
      },
    },
    events: {
      getPublicEventsByPropertyId: {
        propertyId: (propertyId: number | string) =>
          `/v1/public/event/publicEventsByPropertyId/${propertyId}`,
      },
      getPublicChildEvents: {
        eventId: (eventId: number | string) =>
          `/v1/public/event/publicChildEvents/${eventId}`,
      },
      withdraw: {
        unsubscribeEvent: (userId: number, eventId: number) =>
          `v1/event/withdraw/${userId}/${eventId}`,
      },
    },
    collection: {
      getPublicCollectionByPropertyId: {
        id: (id: number | string) =>
          `/v1/public/property/getCollectionByPropertyId/${id}`,
      },
    },
  },
  delete: {
    task: {
      deleteComment: {
        commentId: (commentId: number | string) =>
          `/v1/task/deleteComment/${commentId}`,
      },
      deleteNote: {
        noteId: (noteId: number | string) => `/v1/task/deleteNote/${noteId}`,
      },
    },
    property: {
      deleteVideoLink: {
        linkId: (linkId: number) => `/v1/property/deleteVideoLink/${linkId}`,
      },
    },
    landlord: {
      deleteLandlord: {
        landlordId: (landlordId: number | string) =>
          `/v1/landlord/deleteLandlord/${landlordId}`,
      },
    },
    tenant: {
      candidateScreening: {
        candidateScreeningId: (candidateScreeningId: number | string) =>
          `/v1/tenant/deleteCandidateScreening/${candidateScreeningId}`,
      },
    },
  },
};

const URL_BASE = {
  task: URL,
  property: {},
  post: {
    task: { ...URLS.post.task },
    property: {},
  },
  get: {
    property: {},
    task: URLS.get.task,
  },
  delete: {},
};

// URL_BASE.get.property = { ...URLS.get.property };
// URL_BASE.get.task = { ...URLS.get.task };

// console.log(URLS.get.task.allDoneTasks);

// URL_BASE.task = {
// 	...URL_BASE.delete.task,
// 	...URL_BASE.get.task,
// 	...URL_BASE.post.task,
// }
// URL_BASE.property = {
// 	...URLS.delete.property,
// 	...URLS.get.property,
// 	...URLS.post.property,
// }

// let URL_TASK = { ...URL_BASE.task };
// let URL_PROPERTY = { ...URL_BASE.property };

export { URL_BASE as default, /*URL_TASK, URL_PROPERTY, */ URLS };
